import { render, staticRenderFns } from "./EventListInMembers.vue?vue&type=template&id=52d90bd9&"
import script from "./EventListInMembers.vue?vue&type=script&lang=ts&"
export * from "./EventListInMembers.vue?vue&type=script&lang=ts&"
import style0 from "./EventListInMembers.vue?vue&type=style&index=0&id=52d90bd9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports